// UX-2026-05-27: 简体中文字典 (默认语言).
// key 命名: <module>.<element>.[<state>] (menu.rooms / settings.tab.account)

export const zhCN = {
  // ---- 顶栏 / 导航 ----
  "nav.rooms": "会话",
  "nav.login": "登录",
  "nav.settings": "设置",
  "nav.help": "帮助",
  "nav.about": "关于",
  "nav.logout": "退出登录",
  "nav.brand.title": "返回 ChatBox 官网",

  // ---- 通用动作 ----
  "action.confirm": "确定",
  "action.cancel": "取消",
  "action.save": "保存",
  "action.delete": "删除",
  "action.edit": "编辑",
  "action.close": "关闭",
  "action.back": "返回",
  "action.next": "下一步",
  "action.copy": "复制",
  "action.download": "下载",

  // ---- 房间 ----
  "room.list.title": "会话",
  "room.list.new": "新建会话",
  "room.list.empty": "还没有会话",
  "room.list.empty.cta": "新建第一个会话",
  "room.create.title": "新建会话",
  "room.create.label": "会话名称",
  "room.create.placeholder": "例如：与 AI 结对",
  "room.create.confirm": "创建",
  "room.menu.rename": "重命名",
  "room.menu.rename.title": "重命名会话",
  "room.menu.rename.label": "新名称",
  "room.menu.rename.confirm": "保存",
  "room.menu.clear": "清空历史",
  "room.menu.clear.confirm": "确定清空“{name}”的所有消息？该 Room 本身不会删除。",
  "room.menu.clear.btn": "清空",
  "room.menu.delete": "删除会话",
  "room.menu.delete.confirm": "确定删除“{name}”？会话及所有历史都会被清除，无法恢复。",
  "room.menu.delete.btn": "删除",

  // ---- 成员栏 ----
  "members.title": "成员",
  "members.self": "当前账号",
  "members.online": "在线",
  "members.anon": "匿名用户",
  "members.agent.sub": "AI 终端",
  "members.tip.self": "当前账号",
  "members.tip.agent": "打开 @{name} 终端会话",
  "members.tip.peer": "和 {name} 单独聊天",

  // ---- Composer / 输入框 ----
  "composer.placeholder": "说点什么… (输入 @ 召唤 agent · Enter 发送)",
  "composer.placeholder.connecting": "连接中…",
  "composer.tool.stt": "语音转文字",
  "composer.tool.stt.recording": "听写中",
  "composer.tool.voice": "发语音",
  "composer.tool.voice.recording": "停止录音",
  "composer.tool.attachment": "图片 / HTML",
  "composer.send": "发送",

  // ---- 通用空状态 ----
  "empty.pick": "选一个会话开始",
  "empty.signin": "正在验证身份…",
  "empty.signinRequired": "请先登录。",

  // ---- 设置页 section 标题 ----
  "settings.account.title": "账号",
  "settings.account.nickname": "昵称",
  "settings.account.username": "微信号",
  "settings.account.email": "邮箱",
  "settings.account.avatar": "更换头像",
  "settings.password.title": "密码",
  "settings.password.placeholder1": "新密码 (≥ 8 字符)",
  "settings.password.placeholder2": "确认新密码",
  "settings.password.update": "更新密码",
  "settings.password.saving": "保存中…",
  "settings.password.set": "（已设置）",
  "settings.account.nick.placeholder": "2-32 字",
  "settings.account.nick.unset": "未设昵称",
  "settings.account.nick.empty": "（未设置）",
  "settings.account.uname.placeholder": "6-20 字符 · 字母开头",
  "settings.account.uname.checking": "检查中…",
  "settings.account.uname.ok": "✓ 可用",
  "settings.account.uname.hint": "字母开头, 6-20 字符 · 仅字母 / 数字 / 下划线 / 短横线 · 全站唯一",
  "settings.account.uname.unset": "未设置",
  "common.save": "保存",
  "common.saving": "保存中…",
  "common.edit": "编辑",
  "common.cancel": "取消",
  "settings.ai.title": "AI 模型 (Agent Host)",
  "settings.security.devices.unnamed": "（无名设备）",
  "settings.security.devices.revoked": "已撤销",
  "settings.display.sound.custom.uploaded": "已上传 (存本地, 不上传服务端)",
  "settings.about.localData.subtitle": "本地数据",
  "settings.account.avatar.upload": "上传头像",
  "settings.account.avatar.remove": "移除",
  "settings.password.modify": "修改",
  "settings.display.lang.title": "界面语言",
  "settings.display.lang.sub": "立即生效，跨设备需各自设置（本机存）。",
  "settings.display.sound.title": "通知铃声",
  "settings.display.sound.custom": "自定义",
  "settings.security.devices.title": "本机签名设备",
  "settings.security.devices.loading": "加载中…",
  "settings.security.devices.empty": "尚未注册任何设备 key（重新登录会自动注册）。",
  "settings.about.title": "关于",
  "settings.about.version": "版本",
  "settings.about.checkUpdate": "检查更新",
  "settings.about.checkingUpdate": "检查中…",
  "settings.about.localData": "本地数据",
  "settings.about.localData.sub": "ChatBox 消息历史 / 会话列表 / 偏好设置都存在本机。备份导出 JSON 文件，换设备或重装时再导入即可恢复。",
  "settings.about.localData.warn": "⚠ 导入会清空当前所有数据，用备份完全覆盖。建议先导出一份当前数据。",
  "settings.about.export": "导出数据",
  "settings.about.import": "导入备份",
  "settings.about.helpDocs": "帮助文档",
  "settings.about.feedback": "反馈问题",

  // ---- AI 配置 ----
  "adapter.configured.head": "已配置 {count} 个 AI",
  "adapter.rooms.title": "这些 AI 加入哪些会话？",
  "adapter.rooms.sub": "勾选后保存配置, agent-host 会自动重连到这些 Room。",
  "adapter.rooms.empty": "还没有 Room, 先去左侧 + 建一个。",
  "adapter.advanced.summary": "高级 · 查看完整 toml / 改 device_id",
  "adapter.bootlog.summary": "启动日志 · ~/.chatbox/agent-host-boot.log",
  "adapter.bootlog.empty": "(还没有启动日志, agent-host 启动一次后再来看)",
  "adapter.intro.head": "选模板 + 填表单 → 生成",
  "adapter.intro.desktop": "桌面版会直接保存配置并管理本机 Agent Host。",
  "adapter.intro.web": "Web 版可复制或下载配置文件。",
  "adapter.sub.desktop": "添加 / 移除后会自动保存并重启 Agent Host",
  "adapter.sub.web": "可同时保留 Claude Code、Codex、API、Ollama 等多个",
  "adapter.list.remove": "移除",
  "adapter.template.add.tip": "↑ 点击继续添加 AI；保存后这些 AI 会同时出现在房间右侧成员列表和 @ 菜单里",
  "adapter.form.cancel": "取消",
  "adapter.form.preInstall": "前置安装:",
  "adapter.form.preview": "实时 TOML 预览",
  "adapter.form.add.apply": "添加并应用",
  "adapter.form.add": "添加",
  "adapter.rooms.sub.full": "勾选后保存配置, agent-host 会自动重连到这些 Room。新建 Room 后记得回来勾上。",
  "adapter.rooms.empty.cta": "还没有 Room, 先去左侧 + 建一个。",
  "adapter.web.copy": "复制",
  "adapter.web.download": "下载 agent-host.toml",
  "adapter.web.runHint.line1": "存到",
  "adapter.web.runHint.line2": "然后:",
  "adapter.quota.summary": "访客配额 ({n} 条)",
  "adapter.quota.summary.sub": "按 user_id 限制每日 / 每月用量, 超额拒绝",
  "adapter.quota.empty": "还没有配额规则 · 不配 = 不限. user_id 用 \"*\" 通配, 精确匹配优先.",
  "adapter.quota.col.user": "user_id 或 *",
  "adapter.quota.col.dailyTok": "日 token",
  "adapter.quota.col.dailyUsd": "日 USD",
  "adapter.quota.col.monthlyTok": "月 token",
  "adapter.quota.col.totalUsd": "总 USD",
  "adapter.quota.row.remove": "移除这行",
  "adapter.quota.row.add": "+ 加一条规则",
  "adapter.quota.foot": "改完点上方\"保存并重启\"应用. 留空 = 不限该项. quota=0 不支持(=不限), 完全禁用某 user 删此规则.",
  "agentHost.running": "Agent Host 运行中",
  "agentHost.idle": "Agent Host 未运行",
  "agentHost.notFound": "未找到 sidecar",
  "agentHost.paths.config": "配置:",
  "agentHost.paths.exe": "程序:",
  "agentHost.btn.restart": "保存并重启",
  "agentHost.btn.doctor": "校验配置",
  "agentHost.btn.save": "仅保存",
  "agentHost.btn.start": "启动",
  "agentHost.btn.stop": "停止",
  "agentHost.btn.refresh": "刷新",
  "agentHost.doctor.ok": "doctor 通过",
  "agentHost.doctor.bad": "doctor 输出",
  "bootlog.btn.refresh": "刷新",
  "bootlog.btn.refreshing": "读取中…",
  "bootlog.btn.copy": "复制",
  "bootlog.btn.clear": "清空",
  "bootlog.content.empty": "(空)",
  "bootlog.content.cleared": "(已清空)",

  // ---- 审批卡 ----
  "approval.signing": "签名中…",
  "approval.error": "出错：{msg}",
  "approval.title": "想跑这条命令，需要你批准",
  "approval.meta.invocation": "invocation",
  "approval.meta.hash": "hash",
  "approval.warn.notMine": "这条审批属于 {user}，不是你本人，不可代签。",
  "approval.btn.approve": "批准并执行",
  "approval.btn.deny": "拒绝",
  "approval.sent": "已发送签名，等待 agent 执行",
  "approval.expired": "该请求已超时",

  // ---- 邀请弹窗 ----
  "invite.title": "邀请加入 #{room}",
  "invite.close": "关闭",
  "invite.field.uses": "使用次数",
  "invite.field.ttl": "有效期",
  "invite.field.note": "备注",
  "invite.uses.1": "1 次",
  "invite.uses.5": "5 次",
  "invite.uses.unlimited": "不限",
  "invite.ttl.1d": "1 天",
  "invite.ttl.7d": "7 天",
  "invite.ttl.30d": "30 天",
  "invite.note.placeholder": "只你自己看得到，可以留空",
  "invite.create": "生成邀请链接",
  "invite.creating": "生成中…",
  "invite.created.unlimited": "链接已生成（不限名额）",
  "invite.created.quota": "链接已生成（{n} 个名额）",
  "invite.copy": "复制",
  "invite.created.expires": "把链接发给对方即可。{days} 天后失效。",
  "invite.create.again": "再生成一个",
  "invite.error": "出错：{msg}",
  "invite.retry": "重试",
  "invite.my": "我发出的邀请（{n}）",
  "invite.used.head": "{used}/{cap} 已用",
  "invite.used.unlimited": "{used}/∞ 已用",
  "invite.remain.days": "{n} 天剩余",
  "invite.revoked": "已撤销",
  "invite.see.who": "查看谁加入 ({n})",
  "invite.fold.who": "收起谁加入",
  "invite.revoke": "撤销",
  "invite.redemptions.loading": "加载中…",
  "invite.redemptions.empty": "暂无记录",
  "invite.revoke.confirm": "撤销后链接立即失效，已通过此链接加入的人不受影响。继续？",
  "invite.revoke.failed": "撤销失败：{msg}",
  "invite.copy.fallback": "复制下面这段链接：",
  "invite.load.failed": "加载失败",

  // ---- 设置 ----
  "settings.tab.account": "账号",
  "settings.tab.security": "安全",
  "settings.tab.ai": "AI 配置",
  "settings.tab.display": "显示与通知",
  "settings.tab.about": "关于",

  // ---- 关于 ----
  "about.version": "版本",
  "about.build": "构建时间",
  "about.commit": "提交版本",
  "about.checkUpdate": "检查更新",
  "about.help": "帮助文档",
  "about.feedback": "反馈问题",
  "about.license": "开源协议",

  // ---- 自动更新 ----
  "updater.title.found": "发现新版本 {version}",
  "updater.title.forced": "⚠ 必须更新到 {version}",
  "updater.sub.current": "当前 {version}",
  "updater.body.normal": "有新版本可用，现在更新只需几十秒。",
  "updater.body.forced": "这是一次关键更新，包含安全或兼容性修复，必须更新后才能继续使用 ChatBox。",
  "updater.notes.show": "查看本次更新内容",
  "updater.notes.hide": "收起更新内容",
  "updater.btn.now": "立即更新",
  "updater.btn.later": "稍后再说",
  "updater.btn.exit": "退出应用",
  "updater.btn.installing": "更新中...",
  "updater.progress.prepare": "准备下载...",
  "updater.progress.finished": "安装完成，重启中...",
};

export type DictKey = keyof typeof zhCN;
export type Dict = Record<DictKey, string>;
